/* Overcomers Journal — product page: gallery swap, variant radio cards,
   quantity stepper. Prices arrive pre-formatted from Liquid in data
   attributes, so no client-side money formatting is needed. */

class OjProduct extends HTMLElement {
  connectedCallback() {
    this.mainImage = this.querySelector('[data-oj-main-image]');
    this.priceEl = this.querySelector('[data-oj-price]');
    this.compareEl = this.querySelector('[data-oj-compare]');
    this.addButton = this.querySelector('[data-oj-add-label]');
    this.qtyInput = this.querySelector('[data-oj-qty]');
    this.variantInput = this.querySelector('input[name="id"]');

    this.querySelectorAll('[data-oj-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => this.selectImage(thumb));
    });
    this.querySelectorAll('[data-oj-variant-card]').forEach((card) => {
      card.addEventListener('click', () => this.selectVariant(card));
    });
    this.querySelector('[data-oj-qty-dec]')?.addEventListener('click', () => this.stepQty(-1));
    this.querySelector('[data-oj-qty-inc]')?.addEventListener('click', () => this.stepQty(1));
  }

  selectImage(thumb) {
    if (this.mainImage && thumb.dataset.src) {
      this.mainImage.src = thumb.dataset.src;
      if (thumb.dataset.srcset) this.mainImage.srcset = thumb.dataset.srcset;
      if (thumb.dataset.alt !== undefined) this.mainImage.alt = thumb.dataset.alt;
    }
    this.querySelectorAll('[data-oj-thumb]').forEach((t) => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
  }

  selectVariant(card) {
    const { variantId, priceFormatted, compareFormatted, available } = card.dataset;

    this.querySelectorAll('[data-oj-variant-card]').forEach((c) => c.classList.remove('is-active'));
    card.classList.add('is-active');

    if (this.variantInput) this.variantInput.value = variantId;
    if (this.priceEl) this.priceEl.textContent = priceFormatted;
    if (this.compareEl) {
      this.compareEl.textContent = compareFormatted || '';
      this.compareEl.hidden = !compareFormatted;
    }
    if (this.addButton) {
      const soldOut = available === 'false';
      this.addButton.disabled = soldOut;
      this.addButton.textContent = soldOut
        ? window.variantStrings?.soldOut || 'Sold out'
        : `${this.addButton.dataset.labelPrefix} · ${priceFormatted}`;
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url.toString());
  }

  stepQty(delta) {
    if (!this.qtyInput) return;
    const next = Math.max(1, (parseInt(this.qtyInput.value, 10) || 1) + delta);
    this.qtyInput.value = next;
  }
}

if (!customElements.get('oj-product')) {
  customElements.define('oj-product', OjProduct);
}
